// Relative-day buckets for game and event times, in the league's time zone
// (§15.2). Templates map the bucket to useLabels().ui copy
// ("Tonight 6:00 PM", "Tomorrow", "Next Tuesday"); this file has no words.
//
//   past      the local day is before today
//   tonight   today, starting at or after 17:00 local
//   today     today, before 17:00 local
//   tomorrow  the next local day
//   thisWeek  2–6 local days ahead
//   later     7+ local days ahead

export type RelativeDay = 'past' | 'tonight' | 'today' | 'tomorrow' | 'thisWeek' | 'later'

export const TONIGHT_FROM_HOUR = 17

function parts(d: Date, tz: string): { y: number; m: number; day: number; hour: number } {
  const f = new Intl.DateTimeFormat('en-US', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' })
  const get = (t: string) => Number(f.formatToParts(d).find((p) => p.type === t)?.value)
  return { y: get('year'), m: get('month'), day: get('day'), hour: get('hour') }
}

/** YYYY-MM-DD of the instant in `tz` (for grouping games by day). */
export function dayKey(iso: string | Date, tz: string): string {
  const { y, m, day } = parts(new Date(iso), tz)
  return `${y}-${String(m).padStart(2, '0')}-${String(day).padStart(2, '0')}`
}

const dayNumber = (key: string) => Date.UTC(+key.slice(0, 4), +key.slice(5, 7) - 1, +key.slice(8, 10)) / 86_400_000

export function relativeDay(startsAt: string | Date, tz: string, now: Date = new Date()): RelativeDay {
  const start = new Date(startsAt)
  const diff = dayNumber(dayKey(start, tz)) - dayNumber(dayKey(now, tz))
  if (diff < 0) return 'past'
  if (diff === 0) return parts(start, tz).hour >= TONIGHT_FROM_HOUR ? 'tonight' : 'today'
  if (diff === 1) return 'tomorrow'
  if (diff <= 6) return 'thisWeek'
  return 'later'
}
